// extracted by mini-css-extract-plugin
export var actionText = "_mx-4";
export var container = "_mx-0";
export var leftSection = "_mx-1";
export var rightSection = "_mx-2";
export var settingsButton = "_mx-6";
export var settingsIcon = "_mx-7";
export var shortcut = "_mx-5";
export var shortcutGroup = "_mx-3";